<template>
    <metadata-checkbox
        :metadata="getMetadata"
        :input-id="metadata.name"
        :value="value"
        :required="required"
        :label="getLabel"
        @update:value="emitValue" />
</template>

<script>
import { mapGetters } from 'vuex';
import MetadataCheckbox from '@/components/metadata/inputs/checkbox/MetadataCheckbox.vue';

export default {
    components: {
        MetadataCheckbox
    },
    props: {
        metadata: { type: Object, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: false, default: false },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
        }),
        getMetadata() {
            return {
                ...this.metadata,
                descriptionFr: this.getLabel,
                descriptionEn: this.getLabel
            };
        },
        getLabel() {
            return this.$i18n.t('metadataScreeningFeesAcknowledged.label', ['', this.getLink]);
        },
        getLink() {
            return `<a href="https://covid19.quebec.ca/surveys/cdd2/introduction?language=${this.locale}-ca" target="_blank">${this.$i18n.t('metadataScreeningFeesAcknowledged.linkText')}</a>`;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
